/* EDIT POLL */
export const EDIT_POLL = "EDIT_POLL"
export const EDIT_POLL_SUCCESS = "EDIT_POLL_SUCCESS"
export const EDIT_POLL_CLEAN = "EDIT_POLL_CLEAN"
export const EDIT_POLL_ERROR = "EDIT_POLL_ERROR"
